/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { Options, Unwrappable, RequestResult } from '../.kubb/client'
import type {
  ListManagedPromoCampaignsOptions,
  ListManagedPromoCampaignsResponses,
} from '../types/ListManagedPromoCampaigns'
import { client, withUnwrap } from '../.kubb/client'

/**
 * @description Authenticated QR campaign selector. ADMIN, same-tenant INTEGRATOR, or AFFILIATE_MANAGER explicitly assigned to the owning QR campaign (including across tenants). Grants are checked on every request; tenant filters do not confer access. Managers with no grants receive an empty campaigns array. Returns all assigned tenants unless tenant_id narrows the set. Public challenge listing is unchanged.
 * @summary List accessible Campaign Links campaigns
 * {@link /v1/promo_campaigns}
 */
export function listManagedPromoCampaigns<ThrowOnError extends boolean = true>(
  options: Options<ListManagedPromoCampaignsOptions, ThrowOnError> = {},
): Unwrappable<RequestResult<ListManagedPromoCampaignsResponses, ThrowOnError>> {
  const { client: request = client, ...config } = options

  return withUnwrap(
    request({
      method: 'GET',
      url: '/v1/promo_campaigns',
      security: [
        { type: 'http', scheme: 'bearer' },
        { type: 'apiKey', name: 'Authorization', in: 'header' },
      ],
      ...config,
      throwOnError: config.throwOnError ?? true,
    }) as Promise<RequestResult<ListManagedPromoCampaignsResponses, ThrowOnError>>,
  )
}
